(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.swipe-modal[data-v-8cbd34e1]{position:fixed;top:auto;box-sizing:border-box;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;padding:0;margin:0;overflow:hidden;border:none}.swipe-modal[data-v-8cbd34e1]::backdrop{background-color:#00000080;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}.swipe-modal-content[data-v-8cbd34e1]{width:100%;height:100%}.swipe-modal-content>.panel[data-v-8cbd34e1]{max-height:calc(100dvh - 36px);overflow-y:scroll}.modal-style[data-v-8cbd34e1]{box-sizing:border-box;width:100%;color:#fff;background-color:#1d1b20;border-radius:1rem 1rem 0 0}@media (prefers-color-scheme: light){.modal-style[data-v-8cbd34e1]{color:#000;background-color:#f7f2fa;box-shadow:0 1px 4px #0000005e}}.swipe-modal-drag-handle-wrapper[data-v-8cbd34e1]{position:relative;top:0;flex-shrink:0;height:36px;cursor:grab}.swipe-modal-drag-handle-wrapper[data-v-8cbd34e1]:active{cursor:grabbing}.swipe-modal-drag-handle[data-v-8cbd34e1]{position:absolute;left:50%;width:32px;height:4px;margin:16px 0;content:"";background-color:#ccc;border-radius:2px;transform:translate(-50%)}')),document.head.appendChild(e)}}catch(d){console.error("vite-plugin-css-injected-by-js",d)}})();
import { getCurrentInstance as D, ref as E, watch as Y, nextTick as I, computed as L, defineComponent as O, onMounted as _, onUnmounted as U, openBlock as H, createElementBlock as W, createElementVNode as x, unref as h, renderSlot as F, createCommentVNode as G, pushScopeId as J, popScopeId as z } from "vue";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const X = (t) => typeof t < "u";
function j(t) {
  return JSON.parse(JSON.stringify(t));
}
function q(t, l, s, n = {}) {
  var o, u, m;
  const {
    clone: d = !1,
    passive: e = !1,
    eventName: P,
    deep: f = !1,
    defaultValue: y,
    shouldEmit: M
  } = n, p = D(), S = s || (p == null ? void 0 : p.emit) || ((o = p == null ? void 0 : p.$emit) == null ? void 0 : o.bind(p)) || ((m = (u = p == null ? void 0 : p.proxy) == null ? void 0 : u.$emit) == null ? void 0 : m.bind(p == null ? void 0 : p.proxy));
  let c = P;
  c = c || `update:${l.toString()}`;
  const g = (v) => d ? typeof d == "function" ? d(v) : j(v) : v, b = () => X(t[l]) ? g(t[l]) : y, C = (v) => {
    M ? M(v) && S(c, v) : S(c, v);
  };
  if (e) {
    const v = b(), T = E(v);
    let i = !1;
    return Y(
      () => t[l],
      (a) => {
        i || (i = !0, T.value = g(a), I(() => i = !1));
      }
    ), Y(
      T,
      (a) => {
        !i && (a !== t[l] || f) && C(a);
      },
      { deep: f }
    ), T;
  } else
    return L({
      get() {
        return b();
      },
      set(v) {
        C(v);
      }
    });
}
const A = (t, l) => {
  t.style.setProperty("will-change", l);
}, V = (t) => {
  t.style.removeProperty("will-change");
}, w = "cubic-bezier(0.2, 0.0, 0, 1.0)", k = ({ scopeName: t }) => {
  const l = (o) => getComputedStyle(document.documentElement).getPropertyValue(`--${t}-${o}`);
  return {
    setCssVar: ({ name: o, value: u, fallback: m }) => {
      document.documentElement.style.setProperty(`--${t}-${o}`, u), m == null || m(
        o,
        l(o)
      );
    },
    getCssVar: l,
    removeCssVar: (o) => {
      document.documentElement.style.removeProperty(`--${t}-${o}`);
    }
  };
}, N = ({
  scopeName: t,
  positionStatus: l,
  props: s,
  refs: {
    modalRef: n
  }
}) => {
  const {
    getCssVar: o,
    setCssVar: u
  } = k({ scopeName: t });
  return {
    cancelAnim: () => {
      if (!n.value)
        return;
      const P = () => l.value === "snap" ? s.snapPoint ? o("snapPointPosition") : "0%" : l.value === "full" ? "0%" : "-100%";
      A(n.value, "bottom"), n.value.animate(
        [
          { bottom: o("bottom") },
          {
            bottom: P()
          }
        ],
        {
          duration: 300,
          easing: w
        }
      ).onfinish = () => {
        u({
          name: "movementAmountY",
          value: "0"
        }), u({
          name: "bottom",
          value: P()
        }), n.value && V(n.value);
      };
    },
    moveToSnapPointAnim: () => {
      n.value && s.snapPoint && (A(n.value, "bottom"), n.value.animate(
        [
          { bottom: o("bottom") },
          {
            bottom: o("snapPointPosition")
          }
        ],
        {
          duration: 300,
          easing: w
        }
      ).onfinish = () => {
        u({
          name: "movementAmountY",
          value: "0"
        }), u({
          name: "bottom",
          value: o("snapPointPosition")
        }), l.value = "snap", n.value && V(n.value);
      });
    },
    moveToFullScreenAnim: () => {
      n.value && (A(n.value, "bottom"), n.value.animate(
        [
          { bottom: o("bottom") },
          {
            bottom: "0%"
          }
        ],
        {
          duration: 300,
          easing: w
        }
      ).onfinish = () => {
        u({
          name: "movementAmountY",
          value: "0"
        }), u({
          name: "bottom",
          value: "0%"
        }), l.value = "full", n.value && V(n.value);
      });
    }
  };
}, K = ({
  scopeName: t,
  positionStatus: l,
  props: s,
  refs: { modalRef: n },
  vModel: o
}) => {
  const {
    getCssVar: u,
    setCssVar: m
  } = k({ scopeName: t }), {
    cancelAnim: d,
    moveToSnapPointAnim: e,
    moveToFullScreenAnim: P
  } = N({
    scopeName: t,
    positionStatus: l,
    props: s,
    refs: {
      modalRef: n
    }
  }), f = E(!1), y = E(0);
  return {
    isMouseDown: f,
    handlePointerDown: ({
      mouseEvent: c,
      touchEvent: g,
      eventType: b
    }) => {
      b === "mouse" ? y.value = c.y : y.value = g.touches[0].clientY, f.value = !0, n.value && A(n.value, "bottom");
    },
    handlePointerMove: ({
      mouseEvent: c,
      touchEvent: g,
      eventType: b
    }) => {
      var C, v;
      if (f.value && (m(b === "mouse" ? {
        name: "movementAmountY",
        value: (y.value - c.y).toString()
      } : {
        name: "movementAmountY",
        value: (y.value - g.touches[0].clientY).toString()
      }), !(Number(u("movementAmountY")) > 0 && l.value === "full" || (((C = n.value) == null ? void 0 : C.getBoundingClientRect().top) || 0) < 0) && !(!s.isFullScreen && Number(u("movementAmountY")) > 0))) {
        if ((v = n.value) == null || v.style.setProperty("user-select", "none"), l.value === "snap") {
          m({
            name: "bottom",
            value: `calc(${u("snapPointPosition")} + ${u("movementAmountY")}px)`
          });
          return;
        }
        m({
          name: "bottom",
          value: `calc(0% + ${u("movementAmountY")}px)`
        });
      }
    },
    handlePointerUp: () => {
      var c;
      if (f.value = !1, (c = n.value) == null || c.style.removeProperty("user-select"), Math.abs(Number(u("movementAmountY"))) > 36) {
        if (Number(u("movementAmountY")) < 0)
          switch (l.value) {
            case "full":
              return s.snapPoint ? e() : s.isPersistent ? d() : o.value = !1;
            case "snap":
              return s.isPersistent ? d() : o.value = !1;
            default:
              return;
          }
        switch (l.value) {
          case "snap":
            return s.isFullScreen ? P() : d();
          default:
            return;
        }
      }
      return d();
    }
  };
}, $ = (t) => {
  if (t === "reset") {
    document.documentElement.style.removeProperty("overflow"), document.documentElement.style.removeProperty("overscroll-behavior-y");
    return;
  }
  let l = window, s, n, o;
  document.defaultView ? (l = document.defaultView, s = l.scrollX, n = l.scrollY) : (o = document.documentElement, s = o.scrollLeft, n = o.scrollTop), document.documentElement.style.overflow = t, document.documentElement.style.overscrollBehaviorY = t === "auto" ? "auto" : "none", l.scrollTo(s, n);
}, Q = (t) => (J("data-v-8cbd34e1"), t = t(), z(), t), Z = /* @__PURE__ */ Q(() => /* @__PURE__ */ x("div", { class: "swipe-modal-drag-handle" }, null, -1)), R = /* @__PURE__ */ O({
  __name: "SwipeModal",
  props: {
    isBackdrop: { type: Boolean, default: !0 },
    isDragHandle: { type: Boolean, default: !0 },
    isFullScreen: { type: Boolean, default: !0 },
    isPersistent: { type: Boolean, default: !1 },
    isScrollLock: { type: Boolean, default: !0 },
    modelValue: { type: Boolean, default: !1 },
    snapPoint: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const s = t, n = l, o = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2), {
      getCssVar: u,
      setCssVar: m,
      removeCssVar: d
    } = k({
      scopeName: o
    }), e = E(null), P = E(null), f = q(s, "modelValue", n), y = E("close"), {
      cancelAnim: M
    } = N({
      scopeName: o,
      positionStatus: y,
      props: s,
      refs: {
        modalRef: e
      }
    }), {
      isMouseDown: p,
      handlePointerDown: S,
      handlePointerMove: c,
      handlePointerUp: g
    } = K({
      vModel: f,
      scopeName: o,
      positionStatus: y,
      props: s,
      refs: {
        modalRef: e,
        panelRef: P
      }
    }), b = (i) => {
      if (s.isBackdrop && i.target === i.currentTarget) {
        if (s.isPersistent)
          return M();
        f.value = !1;
      }
    }, C = (i) => {
      i.stopPropagation();
    }, v = () => {
      var a;
      !e.value || (s.isBackdrop ? e.value.showModal() : e.value.show(), (a = e.value) == null || a.style.setProperty("visibility", "visible"), navigator.userAgent.toLowerCase().includes("firefox") || (A(e.value, "opacity"), e.value.animate([
        { opacity: 0 },
        { opacity: 1 }
      ], {
        duration: 200,
        pseudoElement: "::backdrop",
        easing: w
      }).onfinish = () => {
        e.value && V(e.value);
      }), A(e.value, "bottom"), e.value.animate(
        [
          {
            bottom: "-100%"
          },
          {
            bottom: u("snapPointPosition")
          }
        ],
        {
          duration: 300,
          easing: w
        }
      ).onfinish = () => {
        y.value = s.snapPoint ? "snap" : "full", m({
          name: "bottom",
          value: u("snapPointPosition")
        }), s.isScrollLock && $("hidden");
      }, !e.value) || V(e.value);
    }, T = () => {
      if (!e.value)
        return;
      const i = navigator.userAgent.toLowerCase().includes("firefox");
      A(e.value, "opacity"), i || (e.value.animate([
        { opacity: 1 },
        { opacity: 0 }
      ], {
        duration: 300,
        pseudoElement: "::backdrop",
        easing: w
      }).onfinish = () => {
        e.value && V(e.value);
      }), A(e.value, "bottom"), e.value.animate(
        [
          {
            bottom: u("bottom")
          },
          {
            bottom: "-100%"
          }
        ],
        {
          duration: 300,
          easing: w
        }
      ).onfinish = () => {
        var a, r, B;
        m({
          name: "bottom",
          value: "-100%"
        }), y.value = "close", p.value = !1, (a = e.value) == null || a.close(), (r = e.value) == null || r.style.setProperty("display", "initial"), (B = e.value) == null || B.style.setProperty("visibility", "hidden"), $("reset"), e.value && V(e.value);
      };
    };
    return Y(
      () => f.value,
      (i) => {
        i ? v() : T();
      }
    ), Y(
      () => s.isScrollLock,
      (i) => {
        $(i ? "hidden" : "auto");
      }
    ), Y([() => s.snapPoint, () => P.value], ([i, a]) => {
      let r;
      i ? i === "auto" ? r = `calc(${(a == null ? void 0 : a.getBoundingClientRect().height) || 0}px + 36px - 100%)` : r = `calc(${i} - 100%)` : r = "0px", m({
        name: "snapPointPosition",
        value: r
      });
    }, {
      immediate: !0
    }), m({
      name: "bottom",
      value: "-100%"
    }), m({
      name: "movementAmountY",
      value: "0"
    }), _(() => {
      e.value && (e.value.style.setProperty("bottom", `var(--${o}-bottom)`), e.value.addEventListener("cancel", () => {
        f.value = !1;
      }), f.value || (e.value.style.setProperty("display", "initial"), e.value.style.setProperty("visibility", "hidden")));
    }), U(() => {
      d("bottom"), d("movementAmountY"), d("snapPointPosition"), e.value && e.value.removeEventListener("cancel", () => {
      });
    }), (i, a) => (H(), W("dialog", {
      ref_key: "modalRef",
      ref: e,
      class: "swipe-modal modal-style",
      onClick: b
    }, [
      x("div", {
        tabindex: "-1",
        class: "swipe-modal-content",
        onClick: C
      }, [
        x("div", {
          class: "swipe-modal-drag-handle-wrapper",
          onMousedown: a[0] || (a[0] = (r) => h(S)({
            mouseEvent: r,
            eventType: "mouse"
          })),
          onMousemove: a[1] || (a[1] = (r) => h(c)({
            mouseEvent: r,
            eventType: "mouse"
          })),
          onMouseup: a[2] || (a[2] = //@ts-ignore
          (...r) => h(g) && h(g)(...r)),
          onTouchstart: a[3] || (a[3] = (r) => h(S)({
            touchEvent: r,
            eventType: "touch"
          })),
          onTouchmove: a[4] || (a[4] = (r) => h(c)({
            touchEvent: r,
            eventType: "touch"
          })),
          onTouchend: a[5] || (a[5] = //@ts-ignore
          (...r) => h(g) && h(g)(...r))
        }, [
          i.isDragHandle ? F(i.$slots, "drag-handle", { key: 0 }, () => [
            Z
          ], !0) : G("", !0)
        ], 32),
        x("div", {
          ref_key: "panelRef",
          ref: P,
          class: "panel"
        }, [
          F(i.$slots, "default", {}, void 0, !0)
        ], 512)
      ])
    ], 512));
  }
}), ee = (t, l) => {
  const s = t.__vccOpts || t;
  for (const [n, o] of l)
    s[n] = o;
  return s;
}, ne = /* @__PURE__ */ ee(R, [["__scopeId", "data-v-8cbd34e1"]]);
export {
  ne as SwipeModal,
  ne as default
};
